import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { AccountUid, MixedCompositeId } from 'interfaces/linkage'
import { FC, useMemo } from 'react'
import { createProviderAccountBalanceSelector } from 'components/features/pageFilters/pageFilterSelectors'
import { FormPreset } from 'components/atoms/inputs/FormPreset/FormPreset'


type AccountItemProps = {
  pbaCid: MixedCompositeId
  className?: string
}
export const AccountItem: FC<AccountItemProps> = (props) => {
  const { className } = props

  const selector = useMemo(createProviderAccountBalanceSelector, [])
  const balance = useStoreSelector((state) => selector(state, props))

  if (!balance) {
    return null
  }

  return (
    <AccountItemComponent
      uid={ balance.uid }
      title={ balance.name }
      endingDigits={ balance.number }
      className={ className }
    />
  )
}

type AccountItemComponentProps = {
  uid: AccountUid
  title: string
  endingDigits?: string
  className?: string
}
export const AccountItemComponent: FC<AccountItemComponentProps> = (props) => {
  const { className, title, endingDigits, uid } = props

  return (
    <FormPreset.LabeledInput
      name={uid}
      type='switch'
      label={title}
      horizontal
      className={className}
      note={!!endingDigits ? endingDigits : undefined}
    />
  )
}
